import Snippet from "../../../../contents/docs/integrate/_snippets/install-js-snippet.mdx";
import InstallWebPackageManagers from "../../../../contents/docs/integrate/_snippets/install-web-package-managers.mdx";
import * as React from 'react';
export default {
  Snippet,
  InstallWebPackageManagers,
  React
};